import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Company, Employee } from '@models/company';
import { LawFirmEmployeeFields } from '@models/lawFirms';
import {
	GenderOptions,
	GenderType,
	TitleOptions,
	TitleType,
} from '@models/clients';
import { createId } from '@core/util/file';
import { DropdownResult } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { TestHooks } from './create-employee-side-form.hooks';

@Component({
	selector: 'app-create-employee-side-form',
	templateUrl: './create-employee-side-form.component.html',
	standalone: false,
})
export class CreateEmployeeSideFormComponent implements OnInit {
	testHooks = TestHooks;
	public _id;
	public title: TitleType = null;
	public _firstName = '';
	public _lastName = '';
	public _email = '';
	public _phoneNumber = '';
	public gender: GenderType = null;
	public _workPhone = '';
	public _fax = '';
	public labels = LawFirmEmployeeFields;
	public loading = false;
	public _required = false;

	@Input() set name(value: string) {
		const _values = value.split(' ');
		this._lastName = _values[0]?.replace(/,/, '');

		if (_values.length > 1) {
			this._firstName = _values.slice(1).join(' ');
		}
	}

	@Input() minify = false;

	@Input() set firstName(value: string) {
		this._firstName = value;
	}

	@Input() set lastName(value: string) {
		this._lastName = value;
	}

	@Input() set required(value: boolean) {
		this._required = value;
	}

	public titleOptions = [
		{
			items: TitleOptions,
		},
	];

	public genderOptions = GenderOptions;

	@Input() label = '';
	@Input() checkboxLabel = '';
	@Input() company: Company;

	@Input() set employee(value: Employee) {
		this._id = value?.id ?? null;
		this.title = value?.title ?? null;
		this._firstName = this._firstName
			? this._firstName
			: (value?.firstName ?? '');
		this._lastName = this._lastName ? this._lastName : (value?.lastName ?? '');
		this._email = value?.email ?? '';
		this._phoneNumber = value?.phoneNumber ?? '';
		this.gender = value?.gender ?? null;
		this._workPhone = value?.workPhone ?? '';
		this._fax = value?.fax ?? '';
	}

	@Output() onSubmit = new EventEmitter<Employee>();
	@Output() onCancel = new EventEmitter();

	constructor() {
		this.loading = false;
	}

	ngOnInit(): void {
		this.loading = false;
	}

	_onSubmit(form: NgForm): void {
		if (form.valid) {
			this.loading = true;
			const employee: Employee = {
				id: this._id ?? createId(),
				title: this.title,
				firstName: this._firstName,
				lastName: this._lastName,
				phoneNumber: this._phoneNumber,
				email: this._email,
				gender: this.gender,
				workPhone: this._workPhone,
				fax: this._fax,
			};
			this.onSubmit.emit(employee);
		}
	}

	setTitle($event: DropdownResult<{ name: TitleType }>) {
		this.title = $event.result.name;
	}

	setAddress(checked: boolean) {
		if (checked) {
			this._phoneNumber = this.company?.phoneNumber ?? '';
			this._fax = this.company?.faxNumber ?? '';
			this._email = this.company?.email ?? '';
		} else {
			this._workPhone = '';
			this._phoneNumber = '';
			this._fax = '';
			this._email = '';
		}
	}

	_onCancel() {
		this.onCancel.emit();
	}
}
